import { useEffect, useState } from 'react';
import config from '../config';

export default function useMsalContactData(dataType) {
  const decodedToken = config.getDecodedTokenLocalStorage();
  const [contactData, setContactData] = useState();
  useEffect(() => {
    if (decodedToken) {
      if (dataType === 'email') {
        if ('email' in decodedToken) {
          setContactData(decodedToken['email'].toLowerCase());
        } else {
          setContactData(decodedToken['unique_name'].toLowerCase());
        }
      } else if (dataType === 'role') {
        setContactData(decodedToken['roles'][0].toLowerCase());
      }
    }
  }, [decodedToken, dataType]);
  return contactData;
}
